import { ScenarioRun } from "@custom-types/modelRun"
import { MenuItem, Select, SelectChangeEvent } from "@mui/material"
import { RunStatusDto, useGetRunGroupByKeyQuery } from "@store/services/runService"

export type SelectRunFromGroupChangeCallback = (newValue: { key: string; run: ScenarioRun }) => void

type SelectRunFromRunGroupProps = {
  runKey: string
  selectedRunName: string
  onChange: SelectRunFromGroupChangeCallback
}

const SelectRunFromRunGroup = (props: SelectRunFromRunGroupProps) => {
  const { data: runGroupRuns } = useGetRunGroupByKeyQuery(props.runKey)

  if (!runGroupRuns) return

  const handleRunGroupRunChange = ({ target: { value } }: SelectChangeEvent<string>) => {
    const newRunEntry = Object.entries(runGroupRuns.runs).find(
      ([_runKey, run]) => run.scenario_name === value,
    )
    const [runKey, run] = newRunEntry || []
    if (!run || !runKey) return

    props.onChange({ key: runKey, run })
  }

  const doneRuns = Object.values(runGroupRuns.runs).filter((r) => r.status === RunStatusDto.DONE)

  return (
    <Select
      sx={{
        height: "36px",
        fontWeight: 800,
        "& .MuiOutlinedInput-notchedOutline": {
          borderRadius: "3px",
        },
      }}
      value={props.selectedRunName}
      size="small"
      onChange={handleRunGroupRunChange}
    >
      {doneRuns.map((run) => (
        <MenuItem value={run.scenario_name} key={run.model_key}>
          {run.scenario_name}
        </MenuItem>
      ))}
    </Select>
  )
}

export default SelectRunFromRunGroup
